<template lang="pug">
  div(:class="$style.journalTable")
    div(:class="$style.journalTableDesktop")
      div(:class="$style.tableStatic")
        div(:class="[$style.row, $style['--header']]")
          div(:class="$style.col")
          div(:class="$style.col")

        div(
          v-for="(student, idx) in students"
          :key="`row-${idx}`"
          :class="$style.row"
        )
          div(:class="$style.col") {{ idx + 1 }}
          div(:class="$style.col") {{ student.name }}

      div(:class="$style.tableScrolling")
        div(:class="[$style.row, $style['--header']]")
          el-tooltip(
            v-for="(date, idx) in dates"
            :key="`col-header-date-${idx}`"
            :open-delay="500"
            :class="$style.tooltip"
          )
            template(#content)
              div(v-html="getDateTime(date)")
            div(
              :class="[$style.col, { [$style['--important']]: isImportantLesson(date) }]"
              v-html="getFormmatedDate(date)"
            )
        div(
          v-for="(student, sIdx) in formattedStudents"
          :key="`row-${sIdx}`"
          :class="$style.row"
        )
          input(
            v-for="(date, dateId) in dates"
            :ref="`input-row-${sIdx}-col-${dateId}`"
            :key="`col-assessment-${dateId}`"
            :value="getAssessment(student.assessments, date)"
            :class="colClasses(dateId, sIdx)"
            @input="onChangeAssessment($event, student, sIdx, date, dateId)"
            @focus="onFocus(dateId, sIdx)"
            @keyup="onKeyUp"
            @blur="onBlur"
          )

    div(:class="$style.journalTableMobile")
      el-collapse(v-model="activeName" accordion)
        el-collapse-item(
          v-for="(student, sIdx) in formattedStudents"
          :title="student.name"
          :name="`student-${sIdx}`"
        )
          div(:class="$style.collapseContent")
            div(:class="$style.dates")
              div(
                v-for="(date, dIdx) in dates"
                :key="`date-${dIdx}`"
                v-html="getFormmatedDate(date)"
                :class="[$style.col, { [$style['--important']]: isImportantLesson(date) }]"
              )
            div(:class="$style.assessments")
              input(
                ref="input"
                v-for="(date, dateId) in dates"
                :key="`col-assessment-${dateId}`"
                :class="colClasses(dateId, sIdx)"
                :value="getAssessment(student.assessments, date)"
                @input="onChangeAssessment($event, student, sIdx, date, dateId)"
                @focus="onFocus(dateId, sIdx)"
              )

</template>

<script>
  import { isEmpty } from 'lodash';
  import sleep from '@/utils/sleep';

  export default {
    props: {
      students: {
        type: Array,
        default: () => []
      },
      assessments: {
        type: Array,
        default: () => []
      },
      dates: {
        type: Array,
        default: () => []
      },
      homeworks: {
        type: Array,
        default: () => []
      },
      selectedDate: {
        type: [String, null],
        default: null
      },
      homeworkModalIsShow: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        editedCell: null,
        activeName: '1'
      }
    },

    computed: {
      formattedStudents() {
        return this.students.map((student, sIdx) => {
          student.assessments.forEach((assessment, dateId) => {
            if (!isEmpty(this.editedCell) && this.editedCell.sIdx === sIdx && this.editedCell.dateId === dateId) {
              assessment.status = this.editedCell.status;
            } else {
              assessment.status = null;
            }
          })
          return student
        })
      },
    },

    methods: {
      onFocus(dateId, sIdx) {
        this.$emit('update:selected-date', this.dates[dateId]);
        this.editedCell = { sIdx, dateId, status: 'edit' };
      },
      async onBlur() {
        await sleep(1000);
        if (this.homeworkModalIsShow) return;
        this.$emit('update:selected-date', null);
        this.editedCell = null;
      },
      onKeyUp({ key }) {
        if (key === 'ArrowRight') {
          const nextCol = this.editedCell.dateId + 1;

          if (this.dates[nextCol]) {
            this.editedCell.dateId = nextCol;
          }
        } else if (key === 'ArrowLeft') {
          const nextCol = this.editedCell.dateId - 1;

          if (this.dates[nextCol]) {
            this.editedCell.dateId = nextCol;
          }
        } else if (key === 'ArrowDown') {
          const nextRow = this.editedCell.sIdx + 1;

          if (this.students[nextRow]) {
            this.editedCell.sIdx = nextRow;
          }
        } else if (key === 'ArrowUp') {
          const nextRow = this.editedCell.sIdx - 1;

          if (this.students[nextRow]) {
            this.editedCell.sIdx = nextRow;
          }
        }

        this.$refs[`input-row-${this.editedCell.sIdx}-col-${this.editedCell.dateId}`][0].focus();
      },
      colClasses(dateId, sIdx) {
        const colIsActive = this.editedCell && this.editedCell.sIdx === sIdx && this.editedCell.dateId === dateId;
        return [
          this.$style.col,
          this.$style['--input'],
          {
            [this.$style['--error']]: colIsActive && this.editedCell.status === 'error',
            [this.$style['--edit']]: colIsActive && this.editedCell.status === 'edit',
            [this.$style['--success']]: colIsActive && this.editedCell.status === 'success',
          }
        ]
      },
      getAssessment(assessments, date) {
        if (assessments && assessments.length) {
          const result = assessments.find(el => el.dateLesson === date);
          return result ? this.assessments.find(el => el.id === +result.assessmentCode)?.name || '' : '';
        } else {
          return ''
        }
      },

      getFormmatedDate(date) {
        return `<span>${this.$moment(date, 'DD.MM.YYYY').format('DD')}</span><span>${this.$moment(date, 'DD.MM.YYYY').locale('ru').format('MMM')}</span>`
      },

      getDateTime(date) {
        const time = date.split(' ')[1];
        const timeWithoutSeconds = time.substring(0, 5); // Убираем секунды, оставляем HH:MM
        const homework = this.homeworks.find(hw => `${hw.dateLesson} ${hw.timeLesson}` === date);
        const typeWorkload = homework?.typeWorkload || '';
        return typeWorkload ? `${timeWithoutSeconds}<br>${typeWorkload}` : timeWithoutSeconds;
      },

      isImportantLesson(date) {
        const homework = this.homeworks.find(hw => `${hw.dateLesson} ${hw.timeLesson}` === date);
        const typeWorkload = homework?.typeWorkload || '';
        const importantTypes = [
          'Контрольная работа',
          'дифференцированный зачет',
          'экзамен',
          'курсовая работа',
          'индивидуальный проект',
          'экзамен по модулю'
        ];
        return importantTypes.some(type => typeWorkload.toLowerCase().includes(type.toLowerCase()));
      },

      onChangeAssessment($event, student, sIdx, date, dateId) {
        const newValue = $event.target.value;
        const code = this.assessments.find(el => el.name.toLowerCase() === newValue.toLowerCase());
        const assessment = this.getAssessment(student.assessments, date);

        if (code) {
          this.$emit('update',  { sIdx, dateId, assessmentCode: code.id, dateLesson: date })
          if (!isEmpty(this.editedCell)) {
            this.editedCell.status = 'success';
          }
        } else {
          this.editedCell = {
            sIdx,
            dateId,
            status: 'error'
          }

          this.$notify.error({
            message: 'Невалидное значение оценки',
            duration: 3000
          });
          $event.target.value = assessment;
        }
      }
    }
  }
</script>

<style lang="scss" module>
  .journalTable {
    overflow-x: auto;
    overflow-y: visible;
  }

  .journalTableDesktop {
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr;
    color: $regular-text-clr;
    max-height: 100%;
    min-width: min-content;

    @include breakPoints(md) {
      display: none;
    }
  }


  .journalTableMobile {
    display: none;

    @include breakPoints(md) {
      display: block;
    }
  }

  .tooltip {
    cursor: pointer;
  }

  .tableStatic {
    position: sticky;
    left: 0;
    z-index: 5;
    background-color: $basic-white;

    .col {
      &:nth-child(1) {
        width: 30px;
      }

      &:nth-child(2) {
        width: 250px;
        align-items: flex-start;
      }
    }
  }

  .tableScrolling {
    position: relative;
    min-width: max-content;
  }

  .row {
    display: flex;
    min-height: 60px;
    border-bottom: 1px solid $placeholder-text-clr;

    &.--header {
      position: sticky;
      top: 0;
      left: 0;
      border-bottom: 1px solid $placeholder-text-clr;
      background-color: $extra-light-border;
      font-weight: 600;

      .col.--important {
        color: $danger-clr;
      }
    }
  }

  .col {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 50px;
    overflow: hidden;
    padding: 10px;
    border-right: 1px solid $placeholder-text-clr;
    flex-shrink: 0;
    text-overflow: ellipsis;

    @include breakPoints(md) {
      width: 100%;
      height: 50px;
      flex-direction: row;
      border-right: unset;
      column-gap: 5px;
    }

    &.--input {
      outline: none;
      border-top: none;
      border-bottom: none;
      border-radius: 0;
      border-left: none;
      transition-property: box-shadow;
      transition-duration: .3s;

      &:focus {
        -webkit-box-shadow: 0px 0px 0px 1px rgba(2, 136, 209, 1) inset;
        -moz-box-shadow: 0px 0px 0px 1px rgba(2, 136, 209, 1) inset;
        box-shadow: 0px 0px 0px 1px rgba(2, 136, 209, 1) inset;
      }
    }

    &.--edit {
      -webkit-box-shadow: 0px 0px 0px 1px $brand-clr-1 inset;
      -moz-box-shadow: 0px 0px 0px 1px $brand-clr-1 inset;
      box-shadow: 0px 0px 0px 1px $brand-clr-1 inset;

      &:focus {
        -webkit-box-shadow: 0px 0px 0px 1px $brand-clr-1 inset;
        -moz-box-shadow: 0px 0px 0px 1px $brand-clr-1 inset;
        box-shadow: 0px 0px 0px 1px $brand-clr-1 inset;
      }
    }

    &.--error {
      -webkit-box-shadow: 0px 0px 0px 1px $danger-clr inset;
      -moz-box-shadow: 0px 0px 0px 1px $danger-clr inset;
      box-shadow: 0px 0px 0px 1px $danger-clr inset;

      &:focus {
        -webkit-box-shadow: 0px 0px 0px 1px $danger-clr inset;
        -moz-box-shadow: 0px 0px 0px 1px $danger-clr inset;
        box-shadow: 0px 0px 0px 1px $danger-clr inset;
      }
    }

    &.--success {
      -webkit-box-shadow: 0px 0px 0px 1px $success-clr inset;
      -moz-box-shadow: 0px 0px 0px 1px $success-clr inset;
      box-shadow: 0px 0px 0px 1px $success-clr inset;

      &:focus {
        -webkit-box-shadow: 0px 0px 0px 1px $success-clr inset;
        -moz-box-shadow: 0px 0px 0px 1px $success-clr inset;
        box-shadow: 0px 0px 0px 1px $success-clr inset;
      }
    }
  }

  .collapseContent {
    display: flex;
  }

  .dates {
    width: 20%;
    border-right: 1px solid $placeholder-text-clr;

    .col.--important {
      color: $danger-clr;
    }
  }

  .assessments {
    display: flex;
    flex-direction: column;
    width: 80%;
  }
</style>
